import React from 'react';
import { useField } from 'formik';

interface ITextarea {
  label: string;
  name: string;
  placeholder?: string,
  value: string | number | null;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const Textarea = ({
  label,
  value = '',
  placeholder,
  ...props
}: ITextarea) => {
  const [field, meta] = useField(props);

  return (
    <div>
      {label && (
        <label htmlFor={field.name} className='text-sm text-slate-600'>{label}</label>
      )}

      <textarea
        {...field}
        {...props}
        rows={5}
        name={field.name}
        placeholder={placeholder}
        className='flex w-full border border-slate-300 rounded-md p-4 text-sm'
      />

      {meta.touched && meta.error ? <p className='text-red-500 text-xs mt-1'>{meta.error}</p> : null}
    </div>
  );
};
